import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  Table as AriaTable,
  TableProps as AriaTableProps,
} from "react-aria-components";

import { getTextStyle } from "../../../foundations/typography/styles";

export interface TableProps extends AriaTableProps {
  stickyHeader?: boolean;
  hideHeaderBorder?: boolean;
}

export function Table(props: TableProps) {
  const { stickyHeader, hideHeaderBorder } = props;

  return (
    <AriaTable
      {...mergeProps(props, {
        className: css(
          styles.table,
          stickyHeader && styles.stickyHeader,
          stickyHeader && {
            th: { backgroundColor: "var(--background-base)" },
          },
          !hideHeaderBorder && {
            "thead tr": {
              borderBottomWidth: 2,
              borderBottomStyle: "solid",
            },
          }
        ),
      })}
    />
  );
}

const styles = {
  table: css(
    {
      width: "100%",
      boxSizing: "border-box",
      "th,td": { boxSizing: "border-box" },
      borderCollapse: "collapse",
      "tbody tr": {
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
      },
      "tr, th": { borderColor: "var(--border-base)" },
    },

    getTextStyle("form/body-secondary")
  ),
  stickyHeader: css({
    th: {
      position: "sticky",
      top: 0,
      zIndex: 1,
    },
  }),
};
